module.exports = __webpack_public_path__ + "static/img/computer.f0722f40.png";